var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 40,
  width: 40
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.792 30q-1.167 0-1.98-.812-.812-.813-.812-1.98V12.792q0-1.167.812-1.98.813-.812 1.98-.812h14.416q1.167 0 1.98.812.812.813.812 1.98v14.416q0 1.167-.812 1.98-.813.812-1.98.812Z"
})));

export default SvgStop;